"use client"
import React, { createContext } from "react"

type TableScrollContainerContextType = React.RefObject<HTMLDivElement | null>

export const TableScrollContainerContext =
  createContext<TableScrollContainerContextType>({
    current: null,
  })
